import RazorpayCheckout, { ErrorResponse } from "react-native-razorpay";
import * as Sentry from "@sentry/react-native";
import { useCallback } from "react";

export type RazorpaySuccessPayload = {
  razorpay_payment_id: string;
  razorpay_signature: string;
  razorpay_order_id: string;
};

export type RazorpayProcessPayload = {
  description: string;
  image: string;
  currency: string;
  key: string;
  amount: string;
  name: string;
  order_id: string;
  theme: { color: string };
};
const useRazorpay = ({
  processSuccessResult,
  processErrorResult,
}: {
  processSuccessResult: (result: RazorpaySuccessPayload) => void;
  processErrorResult: (
    errorCode?: string | number,
    errorDescription?: string,
    errorObj?: Record<string, any>,
  ) => void;
}) => {
  const processPayment = useCallback(
    async (
      data: RazorpayProcessPayload & {
        orderId?: string;
        amount?: number | string;
      },
    ) => {
      const orderId = data.orderId || data.order_id;
      const options = {
        ...data,
        order_id: orderId,
        amount: Number(data.amount),
      };
      try {
        const response = await RazorpayCheckout.open(options);
        if (response?.razorpay_payment_id) {
          processSuccessResult(response);
        } else {
          processErrorResult();
        }
      } catch (e: unknown) {
        console.log(e);
        Sentry.captureException(e);
        processErrorResult(
          (e as ErrorResponse)?.code,
          (e as ErrorResponse)?.description,
          (e as ErrorResponse)?.error,
        );
      }
    },
    [processErrorResult, processSuccessResult],
  );
  return { processPayment };
};

export default useRazorpay;
